var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_328)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.601 15.8189H33.7619C34.2095 15.8189 34.5736 15.5015 34.5736 15.1132V11.3419C34.5736 9.74603 33.068 8.43994 31.2266 8.43994H29.1338C27.2941 8.43994 25.7867 9.74687 25.7867 11.3419V15.1132C25.7867 15.5015 26.1534 15.8189 26.601 15.8189Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.601 15.8189H27.806C27.3584 15.8189 26.9943 15.5015 26.9943 15.1132V11.3419C26.9943 9.74603 28.5 8.43994 30.3414 8.43994H29.1338C27.2941 8.43994 25.7867 9.74687 25.7867 11.3419V15.1132C25.7867 15.5015 26.1534 15.8189 26.601 15.8189Z",
    fill: "#E6BF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21323 26.2768L5.04036 19.4949C5.01197 18.3158 5.94978 17.3262 7.1281 17.2978C8.30476 17.2669 9.29184 18.2072 9.32023 19.3855L9.5073 26.7336L5.21323 26.2768Z",
    fill: "#FBCE9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35805 29.0468L2.00063 14.8552C1.97223 13.676 2.91005 12.6864 4.08586 12.658C5.26502 12.6271 6.25211 13.5674 6.2805 14.7458L6.46506 22.0746C7.20829 21.7648 8.09851 21.885 8.73318 22.4604C10.6455 24.1932 12.5588 25.926 14.4686 27.6589C16.0002 29.046 16.8077 30.8047 16.8595 32.8715L17.075 41.4814L7.99412 41.706L7.91395 38.4968C7.87637 37.0003 7.29347 35.7267 6.18363 34.7213L4.08837 32.8231C2.98103 31.8185 2.39646 30.5425 2.35805 29.0468Z",
    fill: "#FBBD80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7585 43.7445L6.23123 43.7587C5.92308 43.7587 5.67255 43.5082 5.67255 43.2L5.66754 39.9874C5.66754 39.6801 5.92058 39.4262 6.22873 39.4262L18.7535 39.4154C19.0617 39.4129 19.3122 39.6659 19.3147 39.974L19.3172 43.1867C19.3172 43.494 19.0658 43.7445 18.7585 43.7445Z",
    fill: "#0593FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42081 20.2858C5.65371 20.4607 4.95931 20.8681 4.43244 21.4524C3.00526 23.0316 3.12802 25.4909 4.70468 26.9181L8.33401 30.2059C8.64217 30.4848 9.11984 30.4614 9.3996 30.1541L9.54407 29.9929C9.82299 29.6848 9.7971 29.2046 9.48979 28.9257L5.86296 25.6379C4.98945 24.8471 4.92097 23.4859 5.71181 22.6098C5.92727 22.371 6.18782 22.1931 6.46674 22.0745L6.42081 20.2858Z",
    fill: "#E2AA73"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22622 43.7445H7.72439C7.41707 43.7445 7.16571 43.494 7.16571 43.1858L7.17072 39.9732C7.17072 39.6801 7.40037 39.4362 7.68681 39.4145H6.23123C5.92308 39.412 5.67255 39.665 5.67255 39.9732L5.66754 43.1858C5.66754 43.494 5.91891 43.7445 6.22622 43.7445Z",
    fill: "#0584E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7899 26.2768L38.9603 19.4949C38.9887 18.3158 38.0509 17.3262 36.875 17.2978C35.6984 17.2669 34.7088 18.2072 34.6804 19.3855L34.4958 26.7336L38.7899 26.2768Z",
    fill: "#FBCE9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6418 29.0468L41.9993 14.8552C42.0302 13.676 41.0898 12.6864 39.914 12.658C38.7374 12.6271 37.7503 13.5674 37.7194 14.7458L37.5348 22.0746C36.7916 21.7648 35.9014 21.885 35.2667 22.4604C33.3543 24.1932 31.4436 25.926 29.5313 27.6589C27.9997 29.046 27.1947 30.8047 27.1429 32.8715L26.9249 41.4814L36.0058 41.706L36.0859 38.4959C36.1235 36.9994 36.7089 35.7259 37.8163 34.7204L39.9115 32.8223C41.0222 31.8185 41.6043 30.5425 41.6418 29.0468Z",
    fill: "#FBBD80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2447 43.7445L37.7694 43.7587C38.0776 43.7587 38.3281 43.5082 38.3306 43.2L38.3331 39.9874C38.3331 39.6801 38.0826 39.4262 37.7745 39.4262L25.2472 39.4154C24.939 39.4129 24.6885 39.6659 24.6885 39.974L24.6835 43.1867C24.6835 43.494 24.9365 43.7445 25.2447 43.7445Z",
    fill: "#0593FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5799 20.2858C38.3231 20.4561 39.0213 20.847 39.5683 21.4524C40.9954 23.0316 40.8727 25.4909 39.296 26.9181L35.6692 30.2059C35.361 30.4848 34.8809 30.4614 34.6036 30.1541L34.4591 29.9929C34.1802 29.6848 34.2036 29.2046 34.5109 28.9257L38.1402 25.6379C39.0138 24.8471 39.0797 23.4859 38.2897 22.6098C38.0806 22.378 37.8228 22.1952 37.5348 22.0745L37.5799 20.2858Z",
    fill: "#E2AA73"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7745 43.7445H36.2764C36.5845 43.7445 36.835 43.494 36.835 43.1858L36.8325 39.9732C36.8325 39.6801 36.6029 39.4362 36.3139 39.4145H37.7695C38.0777 39.412 38.3282 39.665 38.3307 39.9732L38.3332 43.1858C38.3332 43.494 38.0818 43.7445 37.7745 43.7445Z",
    fill: "#0584E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1801 6.34301C31.6457 6.34301 32.8408 5.14798 32.8408 3.68239C32.8408 2.21679 31.6457 1.02094 30.1801 1.02094C28.7145 1.02094 27.522 2.21596 27.522 3.68155C27.522 5.14715 28.7145 6.34301 30.1801 6.34301ZM13.8206 6.34301C15.2862 6.34301 16.4812 5.14798 16.4812 3.68239C16.4812 2.21679 15.2854 1.02094 13.8206 1.02094C12.355 1.02094 11.16 2.21596 11.16 3.68155C11.16 5.14715 12.355 6.34301 13.8206 6.34301Z",
    fill: "#FBBD80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2388 15.8189H17.4023C17.8499 15.8189 18.214 15.5015 18.214 15.1132V11.3419C18.214 9.74603 16.7083 8.43994 14.8669 8.43994H12.7742C10.9328 8.43994 9.42712 9.74687 9.42712 11.3419V15.1132C9.42712 15.5015 9.79123 15.8189 10.2388 15.8189Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0012 7.60898C23.7123 7.60898 25.1094 6.2127 25.1094 4.50075C25.1094 2.7888 23.7131 1.39252 22.0012 1.39252C20.2876 1.39252 18.8904 2.7888 18.8904 4.50075C18.8904 6.2127 20.2876 7.60898 22.0012 7.60898Z",
    fill: "#FBBD80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8165 18.6857H26.1867C26.7095 18.6857 27.1362 18.3166 27.1362 17.8623V13.4547C27.1362 11.5891 25.375 10.0625 23.2229 10.0625H20.7778C18.6257 10.0625 16.8645 11.5891 16.8645 13.4547V17.8623C16.8645 18.3158 17.2929 18.6857 17.8165 18.6857Z",
    fill: "#0593FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9364 16.6398L22.0012 17.7028L23.0643 16.6398C24.4422 15.2618 26.6978 15.2618 28.0732 16.6398C29.4511 18.0177 29.4511 20.2708 28.0732 21.6487L22.939 26.7828C22.4229 27.2989 21.5778 27.2989 21.0617 26.7828L15.9275 21.6487C14.5496 20.2708 14.5496 18.0177 15.9275 16.6398C17.3046 15.2627 19.5585 15.2627 20.9364 16.6398Z",
    fill: "#FF4646"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.863 26.8547C22.3419 27.2998 21.5536 27.2764 21.0617 26.7837L15.9275 21.6495C14.5496 20.2716 14.5496 18.0185 15.9275 16.6406C16.837 15.7312 18.1247 15.4213 19.2938 15.7128C18.6718 15.8663 18.1038 16.1872 17.6512 16.6406C16.2733 18.0185 16.2733 20.2716 17.6512 21.6495L22.7854 26.7837C22.8087 26.8071 22.8346 26.8313 22.863 26.8547Z",
    fill: "#E63F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2049 15.6126V13.4539C18.2049 11.5883 19.9661 10.0617 22.1181 10.0617H20.7786C18.6266 10.0617 16.8654 11.5883 16.8654 13.4539V15.9675C17.2849 15.7643 17.7397 15.6438 18.2049 15.6126Z",
    fill: "#0584E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2388 15.8189H11.4464C10.9988 15.8189 10.6322 15.5015 10.6322 15.1132V11.3419C10.6322 9.74603 12.1404 8.43994 13.9817 8.43994H12.7742C10.9328 8.43994 9.42712 9.74687 9.42712 11.3419V15.1132C9.42712 15.5015 9.79123 15.8189 10.2388 15.8189Z",
    fill: "#E6BF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0012 1.39256C22.134 1.39256 22.2659 1.40007 22.3962 1.41594C20.8671 1.60968 19.683 2.91661 19.683 4.50079C19.683 6.08497 20.8663 7.39106 22.3962 7.58564C22.2659 7.60234 22.1331 7.60902 22.0012 7.60902C20.2826 7.60902 18.8905 6.21691 18.8905 4.50079C18.8905 2.78466 20.2826 1.39256 22.0012 1.39256ZM13.8298 1.00006C13.9459 1.00006 14.0594 1.00674 14.1705 1.02177C12.8569 1.18963 11.8414 2.312 11.8414 3.67321C11.8414 5.03191 12.8569 6.15428 14.1705 6.32213C14.0594 6.33633 13.9459 6.34385 13.8298 6.34385C12.355 6.34385 11.16 5.14882 11.16 3.67404C11.16 2.19759 12.355 1.00006 13.8298 1.00006ZM30.1918 1.00006C30.3054 1.00006 30.419 1.00674 30.5326 1.02177C29.2164 1.18963 28.201 2.312 28.201 3.67321C28.201 5.03191 29.2164 6.15428 30.5326 6.32213C30.419 6.33633 30.3054 6.34385 30.1918 6.34385C28.717 6.34385 27.522 5.14882 27.522 3.67404C27.522 2.19759 28.717 1.00006 30.1918 1.00006Z",
    fill: "#E2AA73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.3333,
    height: 43.3333,
    fill: "white",
    transform: "translate(0.333313 0.333313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandPeople);
export default __webpack_public_path__ + "static/media/hand-people.835bebfffe722530189e3bc755c0e477.svg";
export { ForwardRef as ReactComponent };